import {
  Flex,
  Image,
  Box,
  VStack,
  Text,
  ChakraProvider,
  Progress,
} from "@chakra-ui/react";
import LetsStartAI from "@root/assets/images/letsStartAI.svg";

import { PasswordInput } from "@root/components/common/passwordInput/passwordInput";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FormContainer } from "./styles";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setNewPassword, verifyResetPass } from "@root/store/thunks";

import { ROUTE_NAMES, TOAST_VARIANT } from "@root/constants";

interface AllSetValues {
  fullname: string;
  password: string;
  rePassword: string;
}

export const LetsStart: React.FC = () => {
  const { t } = useTranslation("common");
  const initialValues: AllSetValues = {
    fullname: "",
    password: "",
    rePassword: "",
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  // useEffect(() => {
  //   if (token) {
  //     dispatch(verifyResetPass({ payload: token }));
  //   }
  // }, [token]);

  const validate = (values: AllSetValues) => {
    const errors: Partial<AllSetValues> = {};

    if (!values.fullname) {
      errors.fullname = t("login.requiredName");
    } else if (values.fullname.length < 12) {
      errors.fullname = t("login.fullNameValidation");
    }
    if (!values.password) {
      errors.password = t("login.requiredPassword");
    } else if (values.password.length < 6) {
      errors.password = t("login.passwordValidation");
    }

    if (!values.rePassword) {
      errors.rePassword = t("resetPassword.confirmRequiredPassword");
    } else if (values.rePassword !== values.password) {
      errors.rePassword = t("resetPassword.samePasword");
    }

    return errors;
  };

  const navigate = useNavigate();
  const onSuccess = () => {
    setLoading(false);
    navigate(ROUTE_NAMES.RESET_SUCCESS);
  };
  const onSubmitHandler = (values: AllSetValues) => {
    setLoading(true);
    dispatch(
      setNewPassword({
        email: values.fullname, // or values.email if you have an email field
        newPassword: values.password,
        confirmPassword: values.rePassword,
        resetToken: token || "",
        onSuccess,
        onError: () => setLoading(false),
      })
    );
  };

  return (
    <FormContainer>
      <Box
        maxW="sm"
        bg="white"
        p={6}
        borderRadius="lg"
        boxShadow="md"
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <VStack
          spacing={4}
          width="500px"
          alignItems="center"
          display="flex"
          flexDirection="column"
        >
          <Image src={LetsStartAI} alt="LetsStartAI" mt="3px" />
          <Text fontSize="lg" fontWeight="medium" mt="10px" mb="5px">
            {t("letsStart.title")}
          </Text>
          <ChakraProvider>
            <Flex
              flexDirection="row"
              alignItems="center"
              gap={2}
              mt="5px"
              mb="3px"
            >
              <Progress
                colorScheme="purple"
                size="md"
                value={20}
                width="200px"
                borderRadius="20px"
              />
              <Text color="gray.neutral">30%</Text>
            </Flex>
          </ChakraProvider>
        </VStack>
      </Box>
    </FormContainer>
  );
};
